export const SetLoginSettings = (loginSettings) => {
	return async dispatch => {
		await dispatch({
			type: 'SET_LOGIN_SETTINGS',
			payload: loginSettings
		});
	}
}